import { render, staticRenderFns } from "./academy_default.vue?vue&type=template&id=38863552&"
import script from "./academy_default.vue?vue&type=script&lang=js&"
export * from "./academy_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalConfirmation: require('/home/smiley/3df/components/Modal/ModalConfirmation/ModalConfirmation.vue').default,ModalImage: require('/home/smiley/3df/components/Modal/ModalImage/ModalImage.vue').default,ModalForm: require('/home/smiley/3df/components/Modal/ModalForm/ModalForm.vue').default,ModalPassword: require('/home/smiley/3df/components/Modal/ModalPassword/ModalPassword.vue').default,ModalForgot: require('/home/smiley/3df/components/Modal/ModalForgot/ModalForgot.vue').default,ModalLogin: require('/home/smiley/3df/components/Modal/ModalLogin/ModalLogin.vue').default,ModalRegister: require('/home/smiley/3df/components/Modal/ModalRegister/ModalRegister.vue').default,ModalFormSet: require('/home/smiley/3df/components/Modal/ModalFormSet/ModalFormSet.vue').default,Nav: require('/home/smiley/3df/components/Nav/Nav.vue').default,Menu: require('/home/smiley/3df/components/Menu/Menu.vue').default,Footer: require('/home/smiley/3df/components/Footer/Footer.vue').default})
